'use client';

import React, { useEffect, useState } from 'react';
import { LibraryNavigationMenu } from '@diritto/common/navigation/constant';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { FavoriteContentOrder } from '@diritto/common/userReaction/constants';
import { CategoryType } from '@diritto/common/content/constants';
import { LocalStorage } from '@/utils/LocalStorage';
import { MyNavigationBar } from 'app-components/common/navigations/MyNavigationBar';
import { FavoriteContentListView, FavoriteContentParams } from 'app-components/my/FavoriteContentList';
import { useAuthState } from 'contexts/AuthProvider';
import { useTrackingState } from 'contexts/TrackingProvider';
import { BlockAuth } from 'ui-components/common/BlockAuth';
import { Divider } from 'ui-components/common/Divider';
import { StyledTopMenu } from 'ui-components/navigations/styles';

const defaultRefine: FavoriteContentParams = {
  orderBy: FavoriteContentOrder.EpisodeUpdated,
  notiOnly: false,
  categoryType: CategoryType.All,
  showOnlyCompleted: false,
  showOnlyPrivate: false,
};

export const FavoritesPage = () => {
  const { isLoggedIn } = useAuthState();
  const { tracker } = useTrackingState();
  const [refine, setRefine] = useState<FavoriteContentParams>();

  useEffect(() => {
    const restoredRefine = LocalStorage.getItem(LocalStorageKey.MyFavoriteContentsRefineType);
    if (restoredRefine) {
      setRefine({ ...defaultRefine, ...JSON.parse(restoredRefine) });
    } else {
      setRefine(defaultRefine);
    }
  }, []);

  useEffect(() => {
    tracker.track(TrackingEventType.ViewFavorite);
  }, [tracker]);

  return isLoggedIn ? (
    <>
      <StyledTopMenu>
        <MyNavigationBar selectedMenu={LibraryNavigationMenu.Favorites} />
        <Divider />
      </StyledTopMenu>
      {refine && (
        <FavoriteContentListView
          orderBy={refine.orderBy}
          notiOnly={refine.notiOnly}
          categoryType={refine.categoryType}
          showOnlyCompleted={refine.showOnlyCompleted}
          showOnlyPrivate={refine.showOnlyPrivate}
        />
      )}
    </>
  ) : (
    <BlockAuth message="로그인 후 최근 본 작품과\n좋아요한 작품을 살펴보세요." />
  );
};
